module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAWlBMVEUAAAAXdvMYd/IYd/IYd/MXd/IYd/IYd/MjfvMYdvMYdvIYd/EQcO+61/vd7P2y0vuexvqNvPi41fsYd/AYd/L///+Lu/iozPozh/Ti7v7x9/5SmfXF3fxvqve5PYfgAAAAFHRSTlMAYd+E6a/WXP24pJIQ/fv7+9/UVu/Pvt8AAACSSURBVBjTZdBbEoMgDAXQJIKv2ndiRdv9b7PQBKl6v5IzwDAXfhnQE3PdIZQ0ji208on/UqlVeW+nVdFoeovIGIcmIpkFMXTl4CfSeVzSiNAZ3kSuNvZQ2/RKdzUEfERWnMSyKNIG27TV4PU/YRaZw4VTPODxTYTB7ZFSRXtEK6lgqSmjmgUpo3uqKPuHyL233r9SJBe5HCvXJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook.png
// module id = +ces
// module chunks = 1